export default "__VITE_ASSET__DK9a3YFj__"